import type { BugReport } from "./devPanelTypes";

export async function apiFetch<T>(
  path: string,
  method: "GET" | "POST",
  token: string,
  body?: unknown
): Promise<{ ok: true; data: T } | { ok: false; error: string }> {
  try {
    const res = await fetch(path, {
      method,
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: body != null ? JSON.stringify(body) : undefined,
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok || json.ok === false) return { ok: false, error: json.error || `HTTP ${res.status}` };
    return { ok: true, data: json as T };
  } catch (e: any) {
    return { ok: false, error: String(e?.message || e) };
  }
}

export function isUuid(s: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(s);
}

export function statusBadge(status: string) {
  if (status === "open") return "border-rose-300 bg-rose-50 text-rose-800";
  if (status === "in_progress") return "border-amber-300 bg-amber-50 text-amber-800";
  if (status === "resolved") return "border-emerald-300 bg-emerald-50 text-emerald-800";
  return "border-gray-300 bg-gray-100 text-gray-600";
}

export function priorityBadge(priority: string) {
  if (priority === "critical") return "border-red-400 bg-red-50 text-red-900 font-bold";
  if (priority === "high") return "border-orange-300 bg-orange-50 text-orange-800";
  if (priority === "normal") return "border-blue-200 bg-blue-50 text-blue-700";
  return "border-gray-300 bg-gray-50 text-gray-500";
}

export function buildReportLookups(reports: BugReport[]) {
  const modes = Array.from(new Set(reports.map((r) => r.mode).filter(Boolean) as string[])).sort();
  const reporters = Array.from(new Map(reports.filter((r) => r.user_id).map((r) => [r.user_id as string, r.reporter_label || (r.user_id as string)])).entries());
  const organizations = Array.from(new Map(reports.filter((r) => r.organization_id).map((r) => [r.organization_id as string, r.organization_label || (r.organization_id as string)])).entries());
  return { modes, reporters, organizations };
}

